import * as React from 'react';
import S from './SectionTitle.styles';
const SectionTitle = ({ title, titleTheme, linePosition }) => {
    if (!title) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, { "data-line-position": linePosition ?? 'left', "data-title-theme": titleTheme ?? 'gradient' }, title)));
};
export default SectionTitle;
